import { FormField, NonCancelableCustomEvent, Select } from '@amzn/awsui-components-core';
import { SelectProps } from '@amzn/awsui-components-core/select';
import React, { useContext } from 'react';
import { CodeRepoFormCtx } from './CodeRepoFormContext';
import { reviewStatusOptions } from './ReviewStatusOptions';
import { useValidation } from './ValidationHook';
import { requiredFieldValidation } from './Validations';

export const OpenSourceReviewStatusFormField = () => {
  // @ts-expect-error TS2339 - strict migration
  const { repoData, setRepoData } = useContext(CodeRepoFormCtx);
  const validations = [requiredFieldValidation];
  const validationError = useValidation(
    'os_review_status',
    repoData.openSourceReviewStatus,
    validations,
  );
  const changeStatusOption = (event: NonCancelableCustomEvent<SelectProps.ChangeDetail>) => {
    // @ts-expect-error TS7006 - strict migration
    setRepoData((prevState) => ({
      ...prevState,
      openSourceReviewStatus: event.detail.selectedOption.value,
    }));
  };

  return (
    <FormField
      label="Status"
      errorText={validationError}
      stretch
      i18nStrings={{ errorIconAriaLabel: 'Error' }}
    >
      <Select
        data-testid="status-option-select"
        options={reviewStatusOptions}
        // @ts-expect-error TS2322 - strict migration
        selectedOption={reviewStatusOptions.find(
          (o) => o.value === repoData.openSourceReviewStatus,
        )}
        onChange={changeStatusOption}
        ariaRequired
      />
    </FormField>
  );
};
